export default {
  modal: 5000,
  cookiesConsent: 4000,
  headerMobileActive: 2000,
}
